<template>
  <div class="background-small">
    <div class="f sb flex-start pb-4 px-3">
      <h4 class="text-white">
        Get <span class="free-text">Free</span> CS2 Skins
      </h4>
      <button class="history-btn" @click="showHistoryModal = true">
        <i class="fas fa-history"></i>
        History
      </button>
    </div>
    <div class=" pb-4 px-3">
      <span class="letter-spaced danger-text">{{ infoText }}</span>
    </div>
    <div class="wrapper px-3">
      <div v-if="itemLoading" class="collection_grid">
        <ShimmerEffect v-for="index in 1" :key="index" />
      </div>
      <div>
        <div v-if="!itemLoading" class="collection_grid_giveaway py-2">
          <GiveawayCard v-for="item in giveaways" :key="item.name" :item="item" :button-text="buttonText"
            :is-user-authenticated="isUserAuth" :is-button-disabled="isButtonDisabled"
            @join-giveaway="handleJoinGiveaway" @sign-in="handleSignIn" />
        </div>
      </div>
    </div>
    <div v-if="tasks.length > 0" class="tasks-section px-3 py-4">
      <div class="f sb">
        <h6 class="text-white mb-3">Tasks</h6>
        <h6 class="silver mb-3">{{ taskCount.completed }}/{{ tasks.length }} Tasks Remaining</h6>
      </div>

      <div class="task-list">
        <div v-for="task in tasks" :key="task.id" class="task-card f between align-center mb-2"
          :class="{ completed: task.completed }">
          <div class="f align-center gap-2">
            <img :src="task.icon" class="task-icon" />
            <span class="text-white f-15">{{ task.description }}</span>
          </div>
          <button class="task-button" :disabled="task.completed" @click="handleTask(task)">
            {{ task.completed ? 'Completed' : task.buttonText }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <InfoModal v-if="showModal" :message="modalMessage" @close="showModal = false" />

  <!-- History Modal -->
  <div v-if="showHistoryModal" class="modal-overlay" @click.self="showHistoryModal = false">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="text-white">Giveaway History</h5>
        <button class="close-btn" @click="showHistoryModal = false">&times;</button>
      </div>
      <div class="modal-body">
        <div class="tab-bar">
          <button v-for="type in giveawayTypes" :key="type" class="tab-button"
            :class="{ active: historyFilters.type === type }" @click="handleTypeChange(type)">
            <i :class="getTypeIcon(type)"></i>
            {{ type }}
          </button>
        </div>

        <div class="history-list" v-if="pastGiveaways.length > 0">
          <div v-for="giveaway in pastGiveaways" :key="giveaway.id" class="history-item"
            :class="{ 'expanded': giveaway.isExpanded }" @click="toggleGiveaway(giveaway)">
            <div class="history-item-header">
              <div class="item-image">
                <img :src="giveaway.item_detail?.image" :alt="giveaway.item_detail?.short_name">
                <div class="badges">
                  <span class="item-type giveaway-type" :class="giveaway.giveaway_type.toLowerCase()">
                    {{ giveaway.giveaway_type }}
                  </span>
                </div>
              </div>
              <div class="item-summary">
                <h6 class="item-name">{{ giveaway.item_detail?.short_name }}</h6>
                <div class="summary-details">
                  <span class="summary-value">${{ (giveaway.value / 1000).toFixed(2) }}</span>
                  <span class="summary-entries">{{ giveaway.total_entries }} entries</span>
                </div>
              </div>
              <div class="item-status">
                <span class="status-badge" :class="getStatusClass(giveaway)">
                  {{ giveaway.status }}
                </span>
                <div v-if="giveaway.winner" class="winner-preview">
                  <img :src="giveaway.winner.avatar_medium" :alt="giveaway.winner.user_name"
                    class="winner-avatar-small">
                  <span class="winner-name-preview">{{ giveaway.winner.user_name }}</span>
                </div>
              </div>
              <div class="expand-icon">
                <i class="fas" :class="giveaway.isExpanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
              </div>
            </div>

            <div class="history-item-details" v-show="giveaway.isExpanded">
              <div class="details-grid">
                <div class="detail-group">
                  <div class="detail-content">
                    <span class="detail-label">Start Date</span>
                    <span class="detail-value">{{ formatDate(giveaway.starts_at) }}</span>
                  </div>
                </div>
                <div class="detail-group">
                  <div class="detail-content">
                    <span class="detail-label">End Date</span>
                    <span class="detail-value">{{ formatDate(giveaway.expires_at) }}</span>
                  </div>
                </div>
                <div class="detail-group">
                  <div class="detail-content">
                    <span class="detail-label">Total Value</span>
                    <span class="detail-value">${{ (giveaway.value / 1000).toFixed(2) }}</span>
                  </div>
                </div>
                <div class="detail-group">
                  <div class="detail-content">
                    <span class="detail-label">Total Entries</span>
                    <span class="detail-value">{{ giveaway.total_entries }}</span>
                  </div>
                </div>
              </div>
              <div v-if="giveaway.winner" class="winner-details">
                <div class="winner-header">
                  <span class="winner-label">Winner</span>
                  <div class="winner-trophy">
                    <i class="fas fa-trophy"></i>
                  </div>
                </div>
                <div class="winner-card">
                  <div class="winner-avatar-container">
                    <img :src="giveaway.winner.avatar_medium" :alt="giveaway.winner.user_name" class="winner-avatar">
                  </div>
                  <div class="winner-info">
                    <div class="winner-name-container">
                      <span class="winner-name">{{ giveaway.winner.user_name }}</span>
                    </div>
                    <div class="winner-actions">
                      <a :href="giveaway.winner.profile_url" target="_blank" class="winner-action-btn">
                        <i class="fab fa-steam"></i>
                        <span>View Profile</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="empty-state">
          <i class="fas fa-box-open empty-icon"></i>
          <p>No giveaway history found for {{ historyFilters.type.toLowerCase() }} giveaways</p>
        </div>

        <div class="modal-footer">
          <button class="load-more-btn" v-if="hasMoreHistory" @click="loadMoreHistory">
            Load More
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import GiveawayCard from "@/components/cards/GiveawayCard.vue";
import GiveawayService from "@/services/GiveawayService.js"
import ShimmerEffect from "@/components/skeleton/ShimmerItemCard.vue";
import twitter from "@/assets/images/twitter-white.png";
import discord from "@/assets/images/discord-white.png";
import mail from "@/assets/images/mail.png";
import steam from "@/assets/images/steam.png";
import DateUtils from "@/utils/DateUtils.js";
import steamIcon from "@/assets/images/steam-white.png";
import AuthService from "@/services/AuthService.js";
import TaskService from "@/services/TaskService.js";

export default {
  data() {
    return {
      showModal: false,
      isButtonDisabled: false,
      modalMessage: "",
      giveaways: [],
      totalPages: 10,
      loading: true,
      itemLoading: true,
      isDropdownOpen: false,
      steamIcon: steam,
      taskCount: {
        completed: 0,
        inCompleted: 0
      },
      icons: {
        mail: mail,
        discord: discord,
        twitter: twitter,
        steam: steamIcon
      },
      filterObject: {
        pageSize: 20,
        pageNumber: 1,
        orderDir: "DESC",
        orderBy: "date",
        market: "all",
      },
      infoText: "You can participate in giveaways by completing the required tasks.",
      pageTitle: "Get Free CS2 Skins",
      isUserAuth: false,
      tasks: [],
      showHistoryModal: false,
      pastGiveaways: [],
      historyFilters: {
        status: 'ALL',
        type: 'ALL',
        page: 1,
        limit: 10
      },
      hasMoreHistory: false,
      statusOptions: ["ACTIVE", "EXPIRED", "CANCELLED"],
      typeOptions: ['ALL', 'WEEKLY', 'MONTHLY', 'SPECIAL'],
      giveawayTypes: ['ALL', 'Weekly', 'Monthly', 'Special'],
      totalValue: 0,
      wonCount: 0,
      participationCount: 0
    };
  },
  methods: {
    async handleTask(task) {

      switch (task.type) {
        case 'TWITTER_FOLLOW':
          window.open('https://x.com/steamanalyzer', '_blank');
          break;
        case 'MAIL_CONFIRM':
          this.$router.push({ path: '/user-details', hash: '#e_mail' });
          break;
        case 'DISCORD_JOIN':
          window.open('https://discord.com/invite/nfCfpE3d6V', '_blank');
          break;
        case 'TRADE_LINK':
          window.open('/user-details#steam_trade_link', '_blank');
          break;
        default:
          console.warn(`Unhandled task type: ${task.type}`);
      }

      await this.checkTaskCompletion(5000);

      const res = await TaskService.completeTask(task.id);

      this.modalMessage = res.msg;
      this.showInfoModal();
      await this.getTasks();
      await this.getGiveaways();
    },
    async checkTaskCompletion(min) {
      return new Promise(resolve => setTimeout(() => resolve(true), min));
    },
    async getTasks() {
      if (!this.isUserAuth) return this.tasks = [];
      const response = await TaskService.getUserTasks();
      if (!response) return this.tasks = [];
      this.tasks = response.map(task => {
        return {
          ...task,
          buttonText: task.completed ? 'Completed' : 'Complete',
          icon: this.icons[task.icon] || null,
        };
      });

      this.taskCount.completed = (this.tasks.filter(x => x.completed)).length;
    },
    async showInfoModal() {
      this.showModal = true;
      setTimeout(() => {
        this.showModal = false;
      }, 3000);
    },
    async setOrderDir(isAscOrder) {
      this.filterObject.orderDir = this.selectedDirection = isAscOrder
        ? "ASC"
        : "DESC";
      this.sortItems();
    },
    async setOrderBy(option) {
      this.filterObject.orderBy = option.toLowerCase();
      this.selectedOrder = option;
    },
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    async getGiveaways() {
      this.itemLoading = true;

      const response = this.isUserAuth ?
        await GiveawayService.getAllWithDetails({
          status: "ACTIVE",
        }) : await GiveawayService.getAll({
          status: "ACTIVE"
        });

      if (!response) return this.giveaways = [];
      this.giveaways = response.items;
      this.itemLoading = false;
    },
    checkIfMobile() {
      this.isMobile = window.innerWidth < 1000;
    },
    async handleJoinGiveaway(id) {

      const response = await GiveawayService.join({
        giveaway_id: id
      });

      this.buttonText = response.success ? 'Joined' : 'Join Giveaway'
      this.modalMessage = response.msg;
      this.showInfoModal();
      this.getGiveaways()

    },
    async handleSignIn() {
      this.$router.push("/login");
    },
    async checkUser() {
      const response = await AuthService.authCheck();
      this.isUserAuth = response;
    },
    async loadPastGiveaways() {
      const response = await GiveawayService.getAllHistory({
        status: 'EXPIRED',
        type: this.historyFilters.type === 'ALL' ? null : this.historyFilters.type,
        page: this.historyFilters.page,
        limit: this.historyFilters.limit
      });

      if (response?.items) {
        const items = response.items.map(item => ({
          ...item,
          isExpanded: false
        }));

        if (this.historyFilters.page === 1) {
          this.pastGiveaways = items;
        } else {
          this.pastGiveaways = [...this.pastGiveaways, ...items];
        }
        this.hasMoreHistory = response.items.length === this.historyFilters.limit;
      }
    },
    async loadMoreHistory() {
      this.historyFilters.page += 1;
      await this.loadPastGiveaways();
    },
    getStatusClass(giveaway) {
      if (giveaway.winner_id === this.$store.state.user?.id) return 'won';
      if (giveaway.status === 'EXPIRED') return 'expired';
      return 'lost';
    },
    getStatusText(giveaway) {
      if (giveaway.winner_id === this.$store.state.user?.id) return 'WON';
      if (giveaway.status === 'EXPIRED') return 'EXPIRED';
      return 'LOST';
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    handleStatusChange(status) {
      this.historyFilters.status = status;
    },
    handleTypeChange(type) {
      this.historyFilters.type = type;
    },
    getTypeIcon(type) {
      const icons = {
        'ALL': 'fas fa-th-large',
        'Daily': 'fas fa-calendar-day',
        'Weekly': 'fas fa-calendar-week',
        'Monthly': 'fas fa-calendar-alt',
        'Special': 'fas fa-star'
      }
      return icons[type]
    },
    getWinnerName(giveaway) {
      if (giveaway.winner_id === this.$store.state.user?.id) return 'You';
      return giveaway.winner_name || 'Not Drawn';
    },
    updateStats() {
      this.totalValue = this.pastGiveaways.reduce((sum, giveaway) => sum + giveaway.value, 0) / 1000;
      this.totalValue = `$${this.totalValue.toFixed(2)}`;
      this.wonCount = this.pastGiveaways.filter(g => g.winner_id === this.$store.state.user?.id).length;
      this.participationCount = this.pastGiveaways.length;
    },
    toggleGiveaway(giveaway) {
      giveaway.isExpanded = !giveaway.isExpanded;
    },
  },
  async created() {
    await this.checkUser();
    await this.getGiveaways();
    this.getTasks()
    this.loadPastGiveaways()
  },
  mounted() {
    this.checkIfMobile();
    window.addEventListener("resize", this.checkIfMobile);
  },
  computed: {
    DateUtils() {
      return DateUtils;
    },
    buttonText() {
      return this.isUserAuth ? "Join Giveaway" : "Sign In to Join";
    },
  },
  watch: {
    filterObject: {
      handler() {
        this.getGiveaways();
      },
      deep: true,
    },
    'historyFilters.status'() {
      this.historyFilters.page = 1;
      this.loadPastGiveaways();
    },
    'historyFilters.type'() {
      this.historyFilters.page = 1;
      this.loadPastGiveaways();
    },
    pastGiveaways: {
      handler() {
        this.updateStats();
      },
      deep: true
    }
  },
  components: {
    ShimmerEffect,
    GiveawayCard,
  },
};
</script>
<style scoped>
@import "@/assets/style/customTable.css";

p {
  margin-bottom: 0;
}

.letter-spaced {
  letter-spacing: 0.5px;
  font-size: 14px;
}

.collection_grid_giveaway {
  display: flex;
  gap: 20px;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  justify-content: center;
}

.collection_grid {
  display: flex;
  gap: 20px;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  height: 400px;
  justify-content: center;
}

.free-text {
  font-size: 1.85rem;
  color: rgb(31, 255, 31);
  font-weight: bold;
}

.open_case {
  background-image: linear-gradient(to right,
      #25aae1,
      #40e495,
      #30dd8a,
      rgb(38, 133, 92));
  box-shadow: 0 4px 15px 0 rgba(49, 196, 190, 0.75);
  padding: 4px 8px;
  width: 140px;
  font-size: 14px;
  font-weight: bold;
  color: white;
  cursor: pointer;
  margin-top: 5px;
  height: 40px;
  text-align: center;
  border: none;
  background-size: 300% 100%;
  border-radius: 4px;
  moz-transition: all 0.4s ease-in-out;
  -o-transition: all 0.4s ease-in-out;
  -webkit-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
}

.open_case:hover {
  transition: 0.3s;
  background-position: 100% 0;
  moz-transition: all 0.4s ease-in-out;
  -o-transition: all 0.4s ease-in-out;
  -webkit-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
}

.task-list {
  grid-gap: .75rem;
  display: grid;
  gap: .75rem;
  grid-template-columns: repeat(2, 1fr);
}

.task-card {
  background-color: #0000003e;
  border-radius: 4px;
  padding: 1.4rem 1rem;
  border: 1px solid #2e2e3e8f;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.f-15 {
  font-size: 15px;
}

.task-icon {
  width: 24px;
  height: 24px;
}

.task-button {
  background-image: linear-gradient(to right,
      #954ce9 0%,
      #7d32d2 51%,
      #5b28f3 100%);
  background-size: 200% auto;
  background-position: left center;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 3px;
  cursor: pointer;
  width: auto;
  transition: background-position 0.2s ease;
}

.task-card.completed .task-button {
  background-color: #16a34a;
  cursor: default;
}

.task-card.completed {
  opacity: 0.7;
}


@media screen and (max-width: 728px) {
  .task-list {
    grid-template-columns: repeat(1, 1fr);
  }

  .filter-div-mobile {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .mid-span {
    font-size: 16px;
  }

  p {
    font-size: 16px;
  }
}

h4 {
  margin-bottom: 0;
}

.history-btn {
  background-image: linear-gradient(to right,
      #954ce9 0%,
      #7d32d2 51%,
      #5b28f3 100%);
  border: none;
  color: #fff;
  padding: 0.5rem 1rem;
  border-radius: 5px;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.history-btn:hover {
  background: linear-gradient(145deg);
}

.history-btn i {
  font-size: 0.8rem;
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: #1a1a1a;
  border-radius: 8px;
  width: 90%;
  max-width: 800px;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.modal-header {
  background: linear-gradient(145deg, #222, #2a2a2a);
  padding: 1rem 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #333;
}

.modal-header h5 {
  font-size: 1.25rem;
  margin: 0;
  font-weight: 600;
}

.close-btn {
  background: none;
  border: none;
  color: #fff;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0;
  transition: color 0.2s ease;
}

.close-btn:hover {
  color: #ff4655;
}

.modal-body {
  padding: 1.5rem;
  overflow-y: auto;
}

.tab-bar {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1rem;
  border-bottom: 1px solid #333;
  padding-bottom: 1px;
}

.tab-button {
  background: none;
  border: none;
  color: #999;
  padding: 0.75rem 1.5rem;
  font-size: 0.95rem;
  cursor: pointer;
  transition: all 0.2s ease;
  border-bottom: 2px solid transparent;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.tab-button i {
  font-size: 0.9rem;
}

.tab-button:hover {
  color: #fff;
}

.tab-button.active {
  color: #fff;
  border-bottom-color: #ff4655;
}

.history-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  margin-bottom: 2rem;
}

.stat-card {
  background: linear-gradient(145deg, #222, #2a2a2a);
  border-radius: 12px;
  padding: 1rem;
  text-align: center;
  border: 1px solid #333;
}

.stat-value {
  font-size: 1.5rem;
  font-weight: 600;
  color: #fff;
  margin-bottom: 0.5rem;
}

.stat-label {
  color: #999;
  font-size: 0.875rem;
}

.item-details-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.75rem;
}

.detail-group {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.detail-group .detail-label {
  color: #999;
  font-size: 0.75rem;
}

.detail-group .detail-value {
  color: #fff;
  font-size: 0.875rem;
  font-weight: 500;
}

.history-list {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.history-item {
  background: linear-gradient(145deg, #222, #2a2a2a);
  border-radius: 12px;
  border: 1px solid #333;
  transition: all 0.3s ease;
  overflow: hidden;
  cursor: pointer;
  margin-bottom: 0.75rem;
}

.history-item:hover {
  box-shadow: 0 4px 12px rgba(176, 176, 176, 0.2);
}

.history-item.expanded {
  background: linear-gradient(145deg, #2a2a2a, #333);
}

.history-item-header {
  padding: 0.75rem;
  display: grid;
  grid-template-columns: 80px 1fr auto auto;
  align-items: center;
  gap: 1rem;
  position: relative;
}

.item-image {
  position: relative;
  width: 80px;
  height: 60px;
  background: #000;
  border-radius: 8px;
  overflow: hidden;
}

.item-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding: 0.25rem;
}

.badges {
  position: absolute;
  top: 4px;
  right: 4px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.item-type {
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 0.4rem;
  font-weight: 500;
  text-transform: uppercase;
}

.summary-details {
  display: flex;
  gap: 1rem;
  align-items: center;
  margin-top: 0.25rem;
}

.item-name {
  color: #fff;
  font-size: 0.9rem;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.summary-value {
  color: #10b981;
  font-weight: 600;
  font-size: 0.8rem;
}

.summary-entries {
  color: #999;
  font-size: 0.75rem;
}

.item-status {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.status-badge {
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  white-space: nowrap;
}

.winner-preview {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: rgba(0, 0, 0, 0.2);
  padding: 4px 8px;
  border-radius: 20px;
}

.winner-avatar-small {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1.5px solid #ff4655;
}

.winner-name-preview {
  color: #fff;
  font-size: 0.75rem;
  max-width: 120px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.expand-icon {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  transition: transform 0.3s ease;
}

.expanded .expand-icon {
  transform: rotate(180deg);
}

.history-item-details {
  padding: 0.75rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  animation: slideDown 0.3s ease;
  background: rgba(0, 0, 0, 0.2);
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.details-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.detail-group {
  background: rgba(255, 255, 255, 0.05);
  padding: 0.75rem;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  transition: all 0.2s ease;
}

.detail-group:hover {
  background: rgba(255, 255, 255, 0.08);
}

.detail-icon {
  width: 32px;
  height: 32px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #10b981;
}

.detail-content {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.detail-label {
  color: #999;
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.detail-value {
  color: #fff;
  font-size: 0.85rem;
  font-weight: 500;
}

.winner-details {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  overflow: hidden;
}

.winner-header {
  padding: 0.75rem;
  background: rgba(255, 70, 85, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.winner-label {
  color: #ff4655;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 600;
}

.winner-trophy {
  color: #ff4655;
  font-size: 0.9rem;
}

.winner-card {
  padding: 0.75rem;
  display: flex;
  align-items: center;
  gap: 1rem;
}

.winner-avatar-container {
  position: relative;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  overflow: hidden;
  border: 2px solid #ff4655;
  background: #000;
}

.winner-avatar {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.winner-info {
  flex: 1;
  min-width: 0;
}

.winner-name-container {
  margin-bottom: 0.5rem;
}

.winner-name {
  color: #fff;
  font-size: 0.9rem;
  font-weight: 500;
}

.winner-actions {
  display: flex;
  gap: 0.5rem;
}

.winner-action-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.4rem 0.75rem;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  color: #fff;
  text-decoration: none;
  font-size: 0.75rem;
  transition: all 0.2s ease;
}

.winner-action-btn:hover {
  background: rgba(255, 255, 255, 0.15);
  transform: translateY(-1px);
}

.winner-action-btn i {
  font-size: 0.8rem;
}

@media (max-width: 768px) {
  .details-grid {
    grid-template-columns: 1fr;
    gap: 0.5rem;
  }

  .winner-card {
    flex-direction: row;
    align-items: center;
  }

  .winner-avatar-container {
    width: 40px;
    height: 40px;
  }
}

@media (max-width: 480px) {
  .history-item-details {
    padding: 0.5rem;
  }

  .detail-group {
    padding: 0.5rem;
  }

  .detail-icon {
    width: 28px;
    height: 28px;
    font-size: 0.8rem;
  }

  .winner-action-btn {
    padding: 0.3rem 0.5rem;
    font-size: 0.7rem;
  }
}

.giveaway-type {
  top: 2.5rem;
}

.item-type.weekly {
  background: #2563eb;
  color: white;
}

.item-type.monthly {
  background: #059669;
  color: white;
}

.item-type.special {
  background: #dc2626;
  color: white;
}

@media (max-width: 768px) {
  .history-item-header {
    grid-template-columns: 60px 1fr auto;
    padding: 0.5rem;
  }

  .item-image {
    width: 60px;
    height: 45px;
  }

  .item-status {
    grid-column: 1 / -1;
    justify-content: space-between;
    margin-top: 0.5rem;
  }

  .expand-icon {
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
  }
}

.empty-state {
  text-align: center;
  padding: 3rem 0;
  color: #666;
}

.empty-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.empty-state p {
  font-size: 1rem;
}

.modal-footer {
  padding: 1rem;
  display: flex;
  justify-content: center;
  border-top: 1px solid #333;
}

.load-more-btn {
  background: linear-gradient(145deg, #2a2a2a, #333);
  border: none;
  color: #fff;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-size: 0.95rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.load-more-btn:hover {
  transform: translateY(-2px);
  background: linear-gradient(145deg, #333, #2a2a2a);
}

@media (max-width: 640px) {
  .tab-bar {
    overflow-x: auto;
    padding-bottom: 5px;
    margin-bottom: 1.5rem;
  }

  .tab-button {
    padding: 0.75rem 1rem;
    white-space: nowrap;
  }

  .history-stats {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }

  .item-details-grid {
    grid-template-columns: 1fr;
    gap: 0.5rem;
  }

  .item-status {
    min-width: auto;
    align-items: flex-start;
  }

  .winner-container {
    align-items: flex-start;
  }

  .winner-info {
    flex-direction: row;
    align-items: center;
    gap: 0.5rem;
  }

  .winner-avatar {
    width: 20px;
    height: 20px;
  }

  .winner-name {
    font-size: 0.8rem;
    max-width: 100px;
  }


  .modal-content {
    border-radius: 0px;
    width: 100%;
    height: 85vh;
    max-height: 100vh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
}
</style>
